export default __webpack_public_path__ + "static/media/DeleteWorkflow.66009be9.svg";